import useStyles from "isomorphic-style-loader/useStyles";
import _ from "lodash";
import React, { useEffect, useRef, useState } from "react";
import { useMemo } from "react";
import { IMAGE_GEEKO_LTD } from "../../../../../../../constants";
import { Iconfont } from "../../../../../../components/icon/iconfont";
import classes from './style.module.scss';
import { useIntl } from "react-intl";
import { useHistory } from "react-router-dom";

const HeaderImage = ({ image, sender }) => {
    return <div className={classes.HeaderImage}
        style={{
            backgroundImage: sender === 'buyers' ?
                `url(${IMAGE_GEEKO_LTD}/icon/${image}),url(${IMAGE_GEEKO_LTD}/site/pc/icon35.png)` :
                `url(${IMAGE_GEEKO_LTD}/icon/support.jpg)`,
        }}>
    </div>
}

const ReplyTip = (props) => {
    const {reply, getImageUrl} = props
    const imageUrls = reply?.imageUrls
    const messageFormate = useMemo(() => {
        let message = reply?.message === '-' ? '' : reply?.message
        let messages = (message || '').split(/[\s|\n]/)

        return messages.map(m => {
                if (m.indexOf('https://') === 0 || m.indexOf('http://') === 0) {
                    return `<a style="text-decoration:underline;" href="${m}">${m}</a>`
                }
                return m
                }).join(' ')
    }, [reply])

    return <div className={`${classes.ChatTip} ${reply?.sender === 'buyers' ? classes.Buyer: classes.Seller}`}>
      {
        imageUrls?.map(image => (
          <img key={image} src={getImageUrl(image)} />
        ))
      }
      {/* whiteSpace: 'pre-line', */}
      <div style={{ wordBreak: 'break-all', wordWrap: 'break-word'}} dangerouslySetInnerHTML={{__html: messageFormate}}></div>

    </div>
  }

const RateTip = (props) => {
    const { reply, intl, rateTypeChange, rateTextAreaChange, rateConfirm } = props
    const { rateType, rateTxt } = reply
    const rateBox = useRef()

    useEffect(() => {
        if(rateBox?.current){
            rateBox?.current?.scrollIntoView({behavior: 'smooth', block: 'start'})
        }
    }, [rateBox?.current])

    return <div className={`${classes.ChatTip} ${classes.Seller}`} ref={rateBox}>
        <div className={`${classes.RateInfo}`}>
            {intl.formatMessage({ id: 'rate_info' })}
        </div>
        <div className={classes.RateBox}>
            <div style={{ color: rateType == '5' || rateType == 'undefined' || !rateType  ? '#57b936' : '#999' }} onClick={() => rateTypeChange('5')}>
                <Iconfont className={classes.RateIconStyle}>&#xe7af;</Iconfont>
                {intl.formatMessage({ id: 'satisfied' })}
            </div>
            <div style={{ color: rateType == '1' ? '#e64545' : '#999' }} onClick={() => rateTypeChange('1')}>
                <Iconfont className={classes.RateIconStyle} style={{ transform: 'rotate(180deg)' }}>&#xe7af;</Iconfont>
                {intl.formatMessage({ id: 'unsatisfied' })}
            </div>
        </div>
        <textarea className={classes.RateTextArea}
            defaultValue={rateTxt}
            placeholder={intl.formatMessage({ id: 'you_can_rate' })}
            onBlur={(e) => {
                window.scrollTo(0,0)
                rateTextAreaChange(e.target.value)
            }}
            onFocus={()=>{
                document.body.scrollTop = document.body.scrollHeight
            }}
        ></textarea>
        <div className={classes.RateConfirmButton}
             onClick={() => rateConfirm(rateTxt, rateType)}>
             {intl.formatMessage({ id: 'confirm' })}
        </div>

    </div>
}

const QuestionTip = (props) => {
    const {reply, questionTypeList, getImageUrl} = props
    const imageUrls = reply?.imageUrls
    const richTxtFormate = useMemo(() => {
        let reasonList = questionTypeList?.find(qt => qt.value == reply?.questionTypeCode)?.reasons || []
        let reason = reasonList.find(q => q.value == reply?.reasonCode) || ''
        let message = reply?.message === '-' ? '' : reply.message
        let messages = (message || '').split(/[\s|\n]/)
        let messageFormate = messages.map(m => {
            if (m.indexOf('https://') === 0 || m.indexOf('http://') === 0) {
                return `<a style="text-decoration:underline;" href="${m}">${m}</a>`
            }
            return m
        }).join(' ')
        if(reply?.reasonCode && !messageFormate){
            return <div className={classes.QuestionTipReason}>
                        {
                            reason ?
                            reason.value == reasonList[reasonList.length - 1].value ?
                            reply?.reason :
                            reason?.label :'-'
                        }
                    </div>
        } else if(reply?.reasonCode && messageFormate){
            return <React.Fragment>
                        <div className={classes.QuestionTipReason}>
                            {
                                reason ?
                                reason.value == reasonList[reasonList.length - 1]?.value ?
                                reply?.reason :
                                reason?.label :
                                reply?.reasonCode=='100' ?
                                reply?.reason:'-'
                            }
                        </div>
                        <div className={classes.QuestionTipMessage}>
                            {messageFormate}
                        </div>
                    </React.Fragment>
        } else {
            return  <div className={classes.QuestionTipMessage}>
                        {messageFormate}
                    </div>
        }
    }, [reply, questionTypeList])

    

    return <div className={`${classes.ChatTip} ${reply?.sender === 'buyers' ? classes.Buyer: classes.Seller}`}>
        <div className={classes.QuestionTipTxt}>
            {richTxtFormate}
        </div>
        <div className={classes.QuestionTipImgBox}>
            {
                imageUrls?.map(image => (
                    <img key={image} src={getImageUrl(image)} />
                ))
            }
        </div>
    </div>
}

const ReturnTip = (props) => {

    const {reply, order, isApp} = props
    const [orderId, setOrderId] = useState('')
    const [items, setItems] = useState([])
    const history = useHistory();

    useEffect(() => {
        if(reply?.message){
            const jsonMsg = JSON.parse(reply.message)
            setOrderId(jsonMsg?.orderId)
            setItems(jsonMsg?.items)
        }
    }, [reply])

    const intl = useIntl()

    const returnView = () => {
        const packageList = order?.logistics?.packages || []
        const products = packageList?.map(p => p.products)?.flat(Infinity)
        const all = products?.length > 0 ? products : []
        const productReturned = all?.filter(p => p?.returnStatus == 2)
        const hasReturnOrderIdNums = productReturned?.filter(p => p?.returnOrderId)?.map(p => p?.returnOrderId) || []
        const numUnique = Array.from(new Set(hasReturnOrderIdNums))
        if(numUnique?.length == 1){
            const returnId = numUnique[0]
            // 去退货详情
            if(isApp){
                window.location.href = `chic-me://chic.me/returnOrderDetail?returnOrderId=${returnId}&orderId=${order?.id}`
                return
            }
            history.push(`/user/order/return-detail/${returnId}`);
        } else if(numUnique?.length > 1){
            // 去退货列表
            if(isApp){
                window.location.href = 'chic-me://chic.me/orderhistory?pageIndex=5'
                return
            }
            history.push(`/user/order/return`);
        } else {
            // 去订单详情
            if(isApp){
                window.location.href = `chic-me://chic.me/orderDetail?id=${order?.id}`
                return
            }
            history.push(`/user/order/detail/${order?.id}`);
        }
    }

    return (
        <div className={`${classes.ChatTip} ${reply?.sender === 'buyers' ? classes.Buyer: classes.Seller} ${classes.ReturnTip}`}>
            <div className={classes.ReturnTipHead}>
                <div className={classes.Title}>{intl.formatMessage({id:'return_the_oder', defaultMessage:'Return the Order'})}</div>
                <div className={classes.ItemNums}> {items?.length || 0} items</div>
            </div>
            <div className={classes.ProductList}>
                {
                    items?.slice(0,4).map(item => (
                        <img src={item?.imageUrl}></img>
                    ))
                }
                {
                    items?.length > 4 &&
                    <div className={classes.ImgMore}>
                        ...
                    </div>
                }
            </div>
            <div className={classes.OrderId}>
                {intl.formatMessage({id:"order_no"}) + ' '}
                <span>{orderId}</span>
            </div>
            <div className={classes.View}>
                <div className={classes.ViewBtn} onClick={() => returnView()}>
                    <span>{intl.formatMessage({id:"view"})}</span>
                </div>
            </div>
        </div>
    )
}

const GroupReplyHtmls = (props) => {
    const { replies: repliesProps, index: porpsIndex, headSculptureUrl, questionTypeList, intl, rateConfirm, rateTypeChange, rateTextAreaChange, order, isApp} = props
    const replies = useMemo(() => {
        let list = []
        repliesProps.forEach(r => {
            if (r.message || r.imageUrls || (r.reasonCode || r.reason)) {
                list.push(r)
            }
        })
        return list
    }, [repliesProps]);

    const getImageUrl = (url) => {
        if(!url)return ''
        if (url.indexOf('blob') >= 0 || url.indexOf('http') >= 0) {
          return url
        }
        return `${IMAGE_GEEKO_LTD}/ticket/${url}`
    }

    // console.log(replies)
    return <React.Fragment>
        <div className={classes.ChatRows}>
            {
                replies.map((reply, index) => {
                    return (reply?.message || reply?.imageUrls || reply?.reasonCode || reply?.reason) &&
                        <React.Fragment key={index}>
                            {
                                index == 0 &&
                                <div className={classes.TimeTxt}>{porpsIndex}</div>
                            }
                            <div className={`${classes.ChatRow} ${reply?.sender === 'buyers' ? classes.Buyer : classes.Seller}`} >
                                <HeaderImage image={headSculptureUrl} sender={reply?.sender} />
                                {
                                    reply?.isRate ?
                                    <RateTip getImageUrl={getImageUrl} reply={reply} intl={intl} rateTypeChange={rateTypeChange} rateTextAreaChange={rateTextAreaChange} rateConfirm={rateConfirm}></RateTip>: 
                                    reply?.messageType == 1?
                                    <ReturnTip getImageUrl={getImageUrl} order={order} reply={reply} intl={intl} isApp={isApp} rateTypeChange={rateTypeChange} rateTextAreaChange={rateTextAreaChange} rateConfirm={rateConfirm}/>:
                                    reply?.reason && reply?.reasonCode ?
                                    <QuestionTip getImageUrl={getImageUrl} questionTypeList={questionTypeList} reply={reply}></QuestionTip> :
                                    <ReplyTip getImageUrl={getImageUrl} reply={reply} intl={intl} rateTypeChange={rateTypeChange} rateTextAreaChange={rateTextAreaChange} rateConfirm={rateConfirm}/>
                                }
                            </div>
                        </React.Fragment>
                })
            }
        </div>
    </React.Fragment>
}

export const ChatBox = props => {
    useStyles(classes)
    const {
        ticket,
        groupReplies,
        headSculptureUrl,
        intl,
        rateShow,
        showTip,
        addRate,
        rateConfirm,
        rateTypeChange,
        rateTextAreaChange,
        questionTypeList,
        chatDiv,
        order,
        isApp
    } = props

    return (
        <div className={`${classes.ChatBox} ${isApp ? classes.ChatBoxApp: ''}`} ref={chatDiv}>
            {
                ticket?.ticketReplies &&
                _.map(groupReplies(ticket?.ticketReplies), (group, index) => (
                    <div key={index}>
                        <GroupReplyHtmls
                            headSculptureUrl={headSculptureUrl}
                            questionTypeList={questionTypeList}
                            replies={group}
                            index={index}
                            intl={intl}
                            rateConfirm={rateConfirm}
                            rateTextAreaChange={rateTextAreaChange}
                            rateTypeChange={rateTypeChange}
                            order={order}
                            isApp={isApp}
                            />
                    </div>
                ))
            }
            {/* 提示 */}
            {
                !rateShow && ticket?.ticketReplies && showTip && (
                    <div className={classes.ResponseTip}>
                        {intl.formatMessage({ id: "response_time" })}
                    </div>
                )
            }
            {
                (ticket?.id && ticket?.ticketReplies?.length > 0) && <div style={{ marginTop: 20, textAlign: 'center' }}>
                    <div onClick={() => addRate()} style={{ color: '#3aa978', textDecoration: 'none', cursor: 'pointer', }}>
                        <Iconfont className={classes.RATE} style={{ verticalAlign: 'middle' }}>&#xe60d;</Iconfont>
                        <span style={{ textDecoration: 'underline', verticalAlign: 'middle' }}>{intl.formatMessage({ id: "rate" })}</span>
                    </div>
                </div>
            }
        </div>
    )
}